import { Typography } from "@mui/material";

import { SETTLEMENT_STYLES } from "../../../style/styles";

import OtherLiensBalanceActionButtons from "./OtherLiensBalanceActionButtons";
import OtherLiensBalanceModalField from "./OtherLiensBalanceModalField";
import OtherLiensBalanceSingleSelectDropdown from "./OtherLiensBalanceSingleSelectDropdown";
import OtherLiensBalanceTextField from "./OtherLiensBalanceTextField";

const DIGITS_AND_DECIMAL = /^\d*\.?\d*$/;

export default function OtherLiensBalanceForm({
  title,
  values,
  deductionTypeOptions,
  loading,
  cancelDisabled = false,
  saveDisabled,
  onChange,
  onCancel,
  onSave,
}) {
  return (
    <div>
      <div className="px-6 pt-6">
        <Typography
          className="text-[20px]"
          sx={SETTLEMENT_STYLES.modalTitle}
        >
          {title}
        </Typography>
      </div>

      <div className="flex flex-col gap-4 p-6">
        <OtherLiensBalanceModalField
          label="Deduction Type"
          renderValue={
            <OtherLiensBalanceSingleSelectDropdown
              fieldName="deductionType"
              fieldValue={values.deductionType}
              onChange={onChange}
              data={deductionTypeOptions}
            />
          }
        />
        <OtherLiensBalanceModalField
          label="Expense Label"
          renderValue={
            <OtherLiensBalanceTextField
              fieldName="label"
              fieldValue={values.label}
              onChange={onChange}
            />
          }
        />
        <OtherLiensBalanceModalField
          label="Expense Amount"
          renderValue={
            <OtherLiensBalanceTextField
              fieldName="amount"
              fieldValue={values.amount}
              onChange={onChange}
              inputMode="decimal"
              pattern={DIGITS_AND_DECIMAL}
              startAdornment="$"
            />
          }
        />
      </div>

      <OtherLiensBalanceActionButtons
        disableCancel={loading || cancelDisabled}
        disableSave={loading || saveDisabled}
        handleOnClickCancelBtn={onCancel}
        handleOnClickSaveButton={onSave}
      />
    </div>
  );
}
